// The role ladder, and nothing else.
//
// Split out of authz.js so the Vite app can import it: authz.js reaches for the
// database, and the backend UI needs the same order to decide which panels to
// draw. Two copies of this list is how the server and the app quietly stop
// agreeing about who may see the moderation queue — the same argument that put
// `buildMonth` in one module with two renderers, and the catalogue in
// `locales/` with two consumers.
//
// One cumulative ladder, and rank is the only question it answers. `institution`
// was a rung here until 2026-08-06, which made one column mean two things — a
// permission and an account type — and approving somebody's venue application
// raised *their own* row to it. What makes an account an institution is that
// nobody can sign in as it; see `isInstitution()` in lib/paths.js. What opens
// the workspace is membership, not rank.
//
// `guest` is never offered at signup. It is what an anonymous browser gets on
// its first vote or follow, before there is an e-mail or a person to speak of —
// and the rank rises on that same row when an address arrives, which is why
// there is still no merge path and votes cannot be lost.
export const ROLES = ['guest', 'person', 'moderator', 'admin'];

const RANK = Object.fromEntries(ROLES.map((role, index) => [role, index]));

// An unknown role ranks below everything rather than throwing: a row written by
// a newer version of the schema must fail closed, not crash the page.
export function rankOf(role) {
  return RANK[role] ?? -1;
}

export function atLeastRank(role, threshold) {
  return rankOf(role) >= rankOf(threshold);
}
